import { motion } from "framer-motion";
import { Star } from "lucide-react";

export function TestimonialsSection({ témoignages }) {
  if (!témoignages || témoignages.length === 0) return null;

  return (
    <section className="py-20 bg-[#EDE8E1]" data-testid="témoignages-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-[#C9922A] uppercase tracking-[0.2em] text-sm font-semibold mb-3">Témoignages</p>
          <h2 className="text-3xl md:text-4xl text-[#004333]">Ce que disent nos clients</h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {témoignages.slice(0, 6).map((temoignage, index) => (
            <motion.div
              key={temoignage.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-[#FFFDF9] rounded-xl p-8 border border-[#E0D6CA] shadow-[0_2px_8px_rgba(44,30,20,0.05)]"
            >
              <div className="flex gap-0.5 mb-5">
                {[...Array(temoignage.note || 5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#C9922A] text-[#C9922A]" />
                ))}
              </div>
              <p className="text-[#6B5E50] mb-6 italic leading-relaxed text-sm">"{temoignage.texte}"</p>
              <div className="flex items-center gap-3 pt-5 border-t border-[#E8E0D4]">
                <div className="w-9 h-9 bg-[#C9922A]/15 rounded-full flex items-center justify-center text-[#C9922A] font-semibold text-sm">
                  {temoignage.nom.charAt(0)}
                </div>
                <div>
                  <div className="font-semibold text-[#004333] text-sm">{temoignage.nom}</div>
                  <div className="text-xs text-[#8B7D6B]">
                    {temoignage.type_temoignage === "proprietaire" ? "Propriétaire partenaire" : "Voyageur"}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
